module.exports = __webpack_public_path__ + "available jobs 2.svg?152d4b7eb1953acf53abda8b51f06408";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/available jobs 2.svg
// module id = 64
// module chunks = 0